import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import moment from 'moment';
import Swal from 'sweetalert2';



Vue.use(Vuex)
const persistedData = new createPersistedState({
    key:'cad_request_v2',
    storage: localStorage,
    reducer : state => ({
        loggedInUser : state.loggedInUser,
        token: state.token,
        searchItem: state.searchItem,
        selected : state.selected,
        // userGuest : state.userGuest
    })
})

export default new Vuex.Store({
    state:{
        // NOTE : BOSS SENDING AND REGISTER
        isChrome: /Chrome/.test(navigator.userAgent),
        bossCode: [],
        revisionSelection: null,
        siteLayoutSelection: null,
        forRegistration: [],

        // *********************************************************
        mainDialog: false,
        // mainDialogHouse : null,
        disableSelections : false,
        disableApplyNextCad: false,
        token: {},
        tokenExpiration: null,
        loggedInUser : null,
        // userGuest : null,
        allUsers : [],
        rules: {
            // constructionCodeRule: [
            //     (v) => (v || v == undefined || "").length > 0 || "Field is required",
            //     (v) => (v || v == undefined || "").length <= 12 || "Max 12 characters.",
            // ],
            counter: [ (v) => (v || v == undefined || "").length <= 16 || 'Max 16 characters' ],
            noNBString:  [ (v) => !/NB/i.test(v) || "NB not allowed in Boss Codes" ],
            requireOnMultiple : [
                (v) => v.length > 0 || "Field is required"
            ],
            required: [
                (v) => (v == 0 || !!v) || "Field is required",
            ],
            email: [
                (v) =>
                    !v ||
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "E-mail must be valid",
            ],
            password: [
                (v) => !!v || "Field is required",
                // (v) => !v || /[0-9]/.test(v) || "Must contain number",
                // (v) => !v || /[a-zA-Z]/.test(v) || "Must contain letter",
                // v => !v || /[@$!%*?&]/.test(v) || 'Must contain symbol',
                (v) => (v || "").length >= 8 || "Must contain atlest 8 characters.",
            ],
            // hex: [
            //     (v) =>
            //         !v || /[0-9A-Fa-f]{6}/.test(v) || "Must be a hex value",
            // ],
            confirmpassword(temp, actual) {
                return [(v) => temp === actual || "Password must match"];
            },
            // uniqueRole(list) {
            //     return [
            //         (v) => !!v || "Field is required",
            //         (v) => 
            //             // console.log(typeof _.find(list, {name : v}) === 'object', list, v)
            //             typeof _.find(list, {name : v}) === 'undefined' ||
            //             "Role is already exists.",
            //     ];
            // },
            // uniquePermission(list) {
            //     return [
            //         (v) => !!v || "Field is required",
            //         (v) => 
            //             // console.log(typeof _.find(list, {name : v}) === 'object', list, v)
            //             typeof _.find(list, {name : v}) === 'undefined' ||
            //             "Permission is already exists.",
            //     ];
            // },
            // array: [(v) => !v.length == 0 || "Field is required"],
            // higher_number(min, max) {
            //     return [
            //         (v) => !!v || "Field is required",
            //         (v) => v > min || "Must Higher",
            //         (v) => v <= max || "Too much",
            //     ];
            // },
            // positiveNumber: [
            //     (v) => {
            //         if ( !!v  && v >= 0 && v <= 99 && !isNaN(v)) return true;
            //         return "Field is required and must be a number";
            //     },
            // ],
            // capitalLetter: [
            //     (v) => {
            //         if ( !!v  && v >= 0 && v <= 99 && !isNaN(v)) return true;
            //         return "Field is required and must be a number";
            //     },
            // ],
            uniqueRemarks(list) {
                return [
                    (v) => !!v || "Field is required",
                    (v) => 
                        // console.log(typeof _.find(list, {name : v}) === 'object', list, v)
                        typeof _.find(list, {name : v}) === 'undefined' ||
                        "Remark Already exists.",
                ];
            },

            uniqueFloor(flo) {
                return [
                    (v) => !!v || "Field is required",
                    (v) => 
                        // console.log(typeof _.find(list, {name : v}) === 'object', list, v)
                        typeof _.find(flo, {name : v}) === 'undefined' ||
                        "Floor Already exists.",
                ];
            }
        },
        viewMode: false,
        editMode: false,
        filterMode: false,
        
        hugme_hugmeFam : null,
        trapMasua : null,
        loaderx: false,
        radio : null,
        getRadio : null,
        // dialogRadio : null,
        timeout: null,
        loader: false,
        searchItem: '',
        columnRestriction: true,
        // FEEDBACK DATA
        feedback: {
            feedback_customer_code : null,
            revision_number : null,
            feedback_number : null,
            requested_date : null,
            requested_time : null,
            content : null,
            concern : null,
            attachments : [],
        },

        //POP UP MESSAGE
        subRevision : null,
        getFileAttachment : null,

        //Main PageData 
        exisitngColorPers: [],
        additionalAtachments: [],
        copyPreviousAttachment: [],
        verHeader: '',
        rePdfData: null,
        plannerControlNumber : [
			{
				customerCode : null,
				customerCodeSurname : null,
			}

		],
        prevShio : null,
        siteBoss : null,
        getCadNashi : null,
        getHouseId : null,
        sched_header: null,
        bundle_sched: null,
        boss_selection: null,
        finalPlanSiyo: null,
        alvsSelection: null,
        kakou_reason : null,
        hrdprocessMode: false,
        gravityBoss : {
            gravity : null,
            gravity_type : null,
            revision_number : null,
            revision_type : null,
        },  
        editData: null,
        editRevision: null,
        hrd_process_stamp: false,
        previousAttachmentFiles : [],
        customerCodeFromView : null,
        editMode : false,
        attachments : [],
        cadRequestColorPers : [],
        editCadRequestColorPers : [],
        beforeEditColorPers : [],
        cad_request_house_presentation : [],
        cad_request_house_presentation_int : [],
        edit_cad_request_house_presentation : [],
        edit_cad_request_house_presentation_int : [],
        beforeEditHP : [],
        hideColorPersTable : null,
        hideHpTable : null,
        cadRequestData: [],
        cadRequestBasicInformation: {},
        cadRequestLatestRevision: null,
        // cadRequestPdr: {},
        cadRequestPdr: {
            lighting: null,
            outlet_wiring: null,
            optional_switch_outlet: null,
            intercom: null,
            tv_tel_lan: null,
            electrical_drawing_checklist: null,
        },
        editCadRequestPdr: {
            lighting: null,
            outlet_wiring: null,
            optional_switch_outlet: null,
            intercom: null,
            tv_tel_lan: null,
            electrical_drawing_checklist: null,
        },
        stopListSelection: [],
        isBossChecked: false,
        isHrdCpn: false,
        editCadRequestRevisionContent: {
            revision: null,
            design_contract: false,
            calculation_basis: false,
            site_layout: null,
            gravity_type: null,
            isHrdCpn: null,
            kakouirai_reason : null,
            // boss_sending: null,
            site_layout_option: null,
            site_diagram: null,
            // site_boss: null,
            new_site_diagram : null,
            // new_site_boss : null,
            specs_irai: { 
                sash_type: null,  
                specs: null,  
                accessories: [],  
                honeycomb: null,
                },
            dxf_data_request: null,
            color_pers: null,
            house_presentation: null,
            house_presentation_int: null,
            shio_request: null,
            SRS_request: {
                shio_selection: null,
                shio_number: null,
            },
            web_documents: null,
            jiban_plan: null,
            alvs: null,
            status: null,
            structural_request: null,
            pdr: null,
            // denki_gravity: null,
            electrical_drawing: null,
            cross_section: null,
            elevation_section: null,
            stop: null,
            final_plan: null,
            express: null,
            request_attach_from: null,
            stopListSelection: null,
        },
        cadRequestRevisionContent: {
            revision: null,
            isBossChecked: null,
            design_contract: false,
            calculation_basis: false,
            site_layout: null,
            // boss_sending: null,
            gravity_type: null,
            isHrdCpn: null,
            kakouirai_reason : null,
            site_layout_option: null,
            site_diagram: null,
            // site_boss: null,
            new_site_diagram : null,
            // new_site_boss : null,
            specs_irai: { 
                sash_type: null,  
                specs: null,  
                accessories: [],
                honeycomb: null,  
                },
            dxf_data_request: null,
            color_pers: null,
            house_presentation: null,
            house_presentation_int: null,
            shio_request: null,
            SRS_request: {
                shio_selection: null,
                shio_number: null,
            },
            web_documents: null,
            jiban_plan: null,
            alvs: null,
            status: null,
            hrd_process: null,
            structural_request: null,
            pdr: null,
            // denki_gravity: null,
            electrical_drawing: null,
            cross_section: null,
            elevation_section: null,
            stop: null,
            stopListSelection: null,
            final_plan: null,
            express: null,
            request_attach_from: null,
        },
        cadRequestTempRevisionContent: {
            revision: null,
            design_contract: false,
            calculation_basis: false,
            site_layout: null,
            specs_irai: { 
                sash_type: null,  
                specs: null,  
                accessories: [], 
                honeycomb: null, 
                },
            dxf_data_request: null,
            color_pers: null,
            house_presentation: null,
            house_presentation_int: null,
            shio_request: null,
            web_documents: null,
            jiban_plan: null,
            alvs: null,
            structural_request: null,
            pdr: null,
            // denki_gravity: null,
            electrical_drawing: null,
            cross_section: null,
            elevation_section: null,
            stop: null,
            final_plan: null,
            express: null,
            request_attach_from: null,
        },
        actualButton : false,
        draftButton : false,
        deleteButton : false,

		existingRevisions: [],
        edit_webDocs : [],
        structural_request : {
            OPTION_ZEH : null,
            OPTION_GX : null,
            OPTION_1 : null,
            OPTION_2 : null,
            OPTION_W : null,
            OPTION_S : null,

        },

        // section_drawing : {
        //     cross_section: null,
        //     elevation_section: null,
        // },
        // storeRequestContents: [
        //     {text: null, desc: null, value:null},
        // ],
        electrical_request : {
            pdr_title : null,
            radioPdr : null,
            denki_plan_title : null,
            OPTION_1 : null,
            OPTION_2 : null,
            radioGravity : null,
            selectedDrawing : null,
        },
        editFinalPlan : null,
        intRadio : null,
        structOrStop: '',
        bossScheduleData: [],

        registerDate : null,
        cadRequestVersion : [],
        denkiHousetype : null,
        getDrawingRequest : null,
        XmlData: [],
        forHouseCategory : null,
        forAlias : null,
        revisionBossList : null,
        // Master Settings all UPPERCASE
        HOUSE_TYPE_GROUPS: [],
        HOUSE_TYPES: [],
        HP_COLUMNS: [],
        HP_RESTRICTIONS: [],
        HP_RESTRICTIONS_PER_HOUSE: [],
        HP_OBJ_NAME: [],
        HOUSE_TYPE_CATEGORIES: [],
        TILES: [],
        BALCONY_BELT_MAKEUP_TILES: [],
        EAVES_SELECTIONS: [],
        EAVES_GUTTER_SELECTION: [],
        GABLE_SELECTIONS: [],
        SIPOROKS: [],
        VIEW_DIRECTION_SELECTIONS: [],
        VIEW_HEIGHT_SELECTIONS: [],
        COMB_DESIGNS: [],
        LOUVER_ITEMS: [],
        LOUVER_WOODS: [],
        LOUVER_PAINTS: [],
        ROOF_SELECTION : [],
        COLOR_SELECTION_LAYOUT : [],
        SASH_TYPE : [],
        SASH_REINFORCEMENT : [],
        SASH_ACCESSORIES : [],
        SASH_SELECTION : [],
        SPRAY_ITEMS : [],
        LENA_RACK : [],
        SPRAY_SHIPO : [],
        SPRAY_SYNAGIO : [],
        TILES_SEARCH: [],
        SMILE_CUBE_STAIRS: [],
        JIKU_STAIRS: [],
        KITCHEN_SETS: [],
        SMILE_KITCHEN_SETS: [],
        GRAND_KITCHEN_SETS: [],
        SMART_KITCHEN_COUNTERS: [],
        GRAND_KITCHEN_COUNTERS: [],
        SLIT_SLIDERS: [],
        STONE_PATTERNS: [],
        HANGING_CLOSET_LATTICES: [],
        BASE_DRAINERS: [],
        MOLDING_SELECTION: [],
        FANOVA_ENTRANCE: [],
        FIREPROOF_FANOVA: [],
        PRONOVA: [],
        FEATURE_COLOR: [],
        JOINERY_COLOR: [],
        SMART_FLOORING : [],
        SMILE_FLOORING : [],
        CUBE_FLOORING : [],
        JIKU_FLOORING : [],
        GRAND_FLOORING : [],
        SMART_GRAND_STAIR : [],
        ARI_NASHI : [],
        BOSS_CODE : [],
        TILE_COLOR_COMBINATIONS : [],
        REMARKS: [],
        CADEXCEL: [],
        CADMANUAL: [],
        HOUSE_TYPE_REMARKS: [],
        ENTRANCE_DOORS: [],
        PREFECTURES: [], //> currently no page in master setting (no ADD, EDIT, DELETE)
        PORCH_COLORS: [],
        PORCH_TILES: [],
        LATTICE_SLIDING: [],

        FLOORING_SELECTIONS: [],
        KITCHEN_COUNTERS: [],
        HP_STAIRS: [],
        KANABAKARI_SETTINGS: [],
        STOP_LIST: [],
        SEKOU: [],
        FLOOR_LAYOUT: [],

        COLOR_PERS_COLUMN: [],
        COLOR_PERS_RESTRICTION: [],
        COLOR_PERS_OBJ_NAME: [],
        TILE_EXTERNAL: [],
        ELECTRIC_COMPANY : [],

        cadRequestBasicInformationRemarks: [],
        getPrevAttach : null,
        xmlTable : null,
        forMainOverlay : null,
        overlayMain : false,
        previousIcad : null,
        getBossiCad : null,
        getNumber : null,
        forMounHp : null,
        newSite : null,
        newShio : null,
        mainCloseStore : null,
        getXml : null,
        authorityResponse : null,
        countOfAlvsRequest : 0,
        jibanData : 0,
        hokkaidou : [],
        TATAMI : [],
        PH6Planners : [],
        ph6User: null
    },

    actions:{
        // STORE_USER({commit},data){
        //     commit("STORE_USER",data)
        // },
        // ? CHECK VERSION IF UPDATE
        getUpdatedVersion({commit, state}){
            axios({
                method: 'POST',
                url: 'check-update',
                data: {
                version: state.verHeader
                }
            }).then(({data}) => {
                if(data == 'NOT UPDATED'){
                    // alert('バージョンが古い場合またはページが開かない場合は、Ctrl+Shift+Rにて更新してください。')
                    // Swal.fire(
                    //     'New System Update!!',
                    //     'バージョンが古い場合またはページが開かない場合は、Ctrl+Shift+Rにて更新してください。',
                    //     'question'
                    // )

                    Swal.fire({
                        icon: 'info',
                        title: 'New System Update!!',
                        text: '新しいシステムアップデートがあります。システムを新しいバージョンに更新するには、[OK] ボタンをクリックしてください。',
                        // html: 'バージョンが古い場合またはページが開かない場合は、Ctrl+Shift+Rにて更新してください。',
                        // customClass: {
                        //     confirmButton: 'btn btn-danger',
                        // },
                        // buttonsStyling: false,
                        confirmButtonText: 'OK', // Empty text to hide the confirm button
                        allowOutsideClick: false, // Prevent closing by clicking outside the modal
                        allowEscapeKey: false, // Prevent closing with the Escape key
                        showCancelButton: false, // Hide the Cancel button
                        showCloseButton: false, // Hide the close (X) button
                        confirmButtonColor: "#d33",
                    }).then((result) => {
                        if(result.isConfirmed) {
                            // commit('logout')
                            location.reload(true);
                        }
                    })
                }
            })
        },

        async saveToken({commit}, data){
            commit('saveToken', data)
        },

        async login({commit}){ //> only saving data for localStorage, not the actual login.
            axios({
                method : "GET",
                url : 'auth-user',
            })
            .then( response => {
                commit('login', response.data);
                // console.log(response.data,'responseeeee')
            } )
        },

        logout(context){
            context.commit('logout');
        },

        toggleViewMode({commit}){
            commit('toggleViewMode');
        },

        toggleEditMode({commit}){
            commit('toggleEditMode')
        },

        toggleFilterMode({commit}){
            commit('toggleFilterMode')
        },

        toggleLoader({commit}, payload){
            commit('toggleLoader', payload)
        },

        toggleSearchColumn({dispatch, state}, payload){
            const timeOut = 1000
            clearTimeout(state.timeout)
            
            state.timeout = setTimeout(function() {
                var index = Array.from(payload.selector.closest("th").parentNode.children).indexOf(payload.selector.closest("th"));
                if(typeof payload.complexThead !== "undefined" && payload.complexThead){
                    var TopTh = payload.selector.closest("tr").parentNode.firstChild.children[index]
                }else{
                    var TopTh = payload.selector.closest("tr").parentNode.firstChild.children[index]
                }

                if(!TopTh.classList.contains("Filtered")){
                    state[payload.search].push({column: payload.column, val: payload.selector.value})
                    TopTh.classList.add("Filtered")
                }else{
                    var payload_index = _.findIndex(state[payload.search], function(o) { return o.column == payload.column; });
                    if(payload.selector.value.length == 0){
                        TopTh.classList.remove("Filtered")
                        state[payload.search].splice(payload_index, 1)
                    }else{
                        if(payload_index > -1 ){
                            state[payload.search][payload_index].val = payload.selector.value
                        }else{
                            state[payload.search].push({column: payload.column,val: payload.selector.value})
                        }
                    }
                }

                dispatch(payload.action)
            }, timeOut);
        },

        async cadRequestVer({commit}){
            await axios({
                method : 'post',
                url : '/api/cad_version',
                data : {}
            }).then( (res) => {
                commit('cadRequestVer', res.data)
            })
        },

        // async getXmlData({commit}){
        //     await axios({
        //         method : 'post',
        //         url : '/api/xml_bundle',
        //         data : {}
        //     }).then( (res) => {
        //         commit('getXmlData', res.data)
        //     })
        // },

        // async cadRequestVer({commit}){
        //     await axios({
        //         method : 'post',
        //         url : '/api/cad_version',
        //         data : {}
        //     }).then( (res) => {
        //         commit('cadRequestVer', res.data)
        //     })
        // },


        // Master Settings - with _
        async _getSekou({ commit}){
            await axios({
                method: 'POST',
                url: '/api/stop_list',
                data: {}
            }).then( (res) => {
                commit('_getSekou', res.data)
            })
        },

        async _getStopList({ commit}){
            await axios({
                method: 'POST',
                url: '/api/stop_list',
                data: {}
            }).then( (res) => {
                commit('_getStopList', res.data)
            })
        },


        async _getHouseTypeGroups({ commit}){
            await axios({
                method: 'POST',
                url: '/api/house_type_group',
                data: {}
            }).then( (res) => {
                commit('_getHouseTypeGroups', res.data)
            })
        },

        async _getCadBasicInforRemarks({ commit }) {
            await axios({
                method: 'POST',
                url: '/api/cad_basic_info_remarks',
                data: {}
            }).then( (res) => {
                commit('_getCadBasicInforRemarks', res.data)
            })
        },


        async _getHouseTypes({ commit }){
            await axios({
                method: 'POST',
                url: '/api/house_types', // pag master settings may slash ('/') sa unahan ng api.
                data: {}
            })
            .then( (res) => {
                commit('_getHouseTypes', res.data)
            } )
        },

        async _getHpColumn({ commit }){
            await axios({
                method: 'POST',
                url: '/api/hp_col', // pag master settings may slash ('/') sa unahan ng api.
                data: {}
            })
            .then( (res) => {
                commit('_getHpColumn', res.data)
            } )
        },

        async _getHpRestriction({ commit }){
            await axios({
                method: 'POST',
                url: '/api/hp_res', // pag master settings may slash ('/') sa unahan ng api.
                data: {}
            })
            .then( (res) => {
                commit('_getHpRestriction', res.data)
            } )
        },

        async _getHpRestrictionPerHouseType({ commit, state }){
            await axios({
                method: 'POST',
                url: '/api/hp_res/get_by_house', // pag master settings may slash ('/') sa unahan ng api.
                data: {
                    house_id : state.cadRequestBasicInformation.house_type_id
                }
            })
            .then( (res) => {
                commit('_getHpRestrictionPerHouseType', res.data)
            } )
        },

        async _getHpObjName( {commit, state} ){
            await axios({
                method: 'POST',
                url: '/api/hp_res/hpObjName',
                data: {
                    house_id : state.cadRequestBasicInformation.house_type_id
                }
            }).then( (res) => {
                commit('_getHpObjName', res.data)
            })
        },

        async _getHouseTypeCategories({ commit }){
            await axios({
                method: 'POST',
                url: '/api/house_type_categories',
                data: {}
            }).then((res) => {
                commit('_getHouseTypeCategories', res.data)
            })
        },

        // _updateHousTypeCategories({ commit }, payload){
        //     commit('_updateHousTypeCategories', payload);
        // }

        async _getTiles({ commit, state }){
            await axios({
                method: 'POST',
                url: '/api/tile_colors',
                data: {
                    search : state.TILES_SEARCH
                }
            }).then((res) => {
                commit('_getTiles', res.data)
            })
        },

        async _getRoofSelection({ commit }){
            await axios({
                method: 'GET',
                url: '/api/roof_selections',
                data: {}
            }).then((res) => {
                commit('_getRoofSelection', res.data)
                console.log(res.data,'daatttaa')
            })
        },

        async _getColorSelectionLayout({ commit }){
            await axios({
                method: 'GET',
                url: '/api/colorSelectionLayout',
                data: {}
            }).then((res) => {
                commit('_getColorSelectionLayout', res.data)
            })
        },

        async _getSashType({ commit }){
            await axios({
                method: 'GET',
                url: '/api/sashType',
                data: {}
            }).then((res) => {
                commit('_getSashType', res.data)
            })
        },

        async _getSashReinforcement({ commit }){
            await axios({
                method: 'GET',
                url: '/api/sashReinforcement',
                data: {}
            }).then((res) => {
                commit('_getSashReinforcement', res.data)
            })
        },

        async _getSashAccessories({ commit }){
            await axios({
                method: 'GET',
                url: '/api/sashAccessories',
                data: {}
            }).then((res) => {
                commit('_getSashAccessories', res.data)
            })
        },

        async _getSashSelection({ commit }){
            await axios({
                method: 'GET',
                url: '/api/sashSelection',
                data: {}
            }).then((res) => {
                commit('_getSashSelection', res.data)
            })
        },

        async _getSprayItems({ commit }){
            await axios({
                method: 'GET',
                url: '/api/sprayItems',
                data: {}
            }).then((res) => {
                commit('_getSprayItems', res.data)
            })
        },

        async _getLenaRack({ commit }){
            await axios({
                method: 'GET',
                url: '/api/lenaRack',
                data: {}
            }).then((res) => {
                commit('_getLenaRack', res.data)
            })
        },

        async _getSprayShipo({ commit }){
            await axios({
                method: 'GET',
                url: '/api/sprayShipo',
                data: {}
            }).then((res) => {
                commit('_getSprayShipo', res.data)
            })
        },

        async _getSpraySynagio({ commit }){
            await axios({
                method: 'GET',
                url: '/api/spraySynagio',
                data: {}
            }).then((res) => {
                commit('_getSpraySynagio', res.data)
            })
        },

        async _getBalconyBeltMakeupTiles({ commit }){
            await axios({
                method: 'POST',
                url: '/api/balcony_belt_makeup_tiles',
                data: {}
            }).then((res) => {
                commit('_getBalconyBeltMakeupTiles', res.data)
            })
        },

        async _getEavesSelections( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/eaves_selections',
                data: {}
            }).then( (res) => {
                commit('_getEavesSelections', res.data)
            })
        },

        async _getEavesGutterSelections( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/eaves_gutter_selections',
                data: {}
            }).then((res) => {
                commit('_getEavesGutterSelections', res.data)
            })
        },

        async _getGableSelections( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/gable_selections',
                data: {}
            }).then( (res) => {
                commit('_getGableSelections', res.data)
            })
        },

        async _getSiporoks( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/siporoks',
                data: {}
            }).then( (res) => {
                commit('_getSiporoks', res.data)
            })
        },

        async _getViewDirectionSelections( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/view_direction_selections',
                data: {}
            }).then( (res) => {
                commit('_getViewDirectionSelections', res.data)
            })
        },

        async _getViewHeightSelections( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/view_height_selections',
                data: {}
            }).then( (res) => {
                commit('_getViewHeightSelections', res.data)
            })
        },

        async _getCombDesigns( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/comb_designs',
                data: {}
            }).then( (res) => {
                commit('_getCombDesigns', res.data)
            })
        },

        async _getLouverItems( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/louver_items',
                data: {}
            }).then( (res) =>{
                commit('_getLouverItems', res.data)
            })
        },

        async _getLouverWoods( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/louver_woods',
                data: {}
            }).then( (res) =>{
                commit('_getLouverWoods', res.data)
            })
        },

        async _getLouverPaints( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/louver_paints',
                data: {}
            }).then( (res) => {
                commit('_getLouverPaints', res.data)
            })
        },

        async _getSmileCubeStairs( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/smile_cube_stairs',
                data: {}
            }).then( (res) => {
                commit('_getSmileCubeStairs', res.data)
            })
        },

        async _getJikuStairs( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/jiku_stairs',
                data: {}
            }).then( (res) => {
                commit('_getJikuStairs', res.data)
            })
        },

        async _getKitchenSets( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/kitchen_sets',
                data: {}
            }).then( (res) => {
                commit('_getKitchenSets', res.data)
            })
        },

        async _getSmileKitchenSets( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/smile_kitchen_sets',
                data: {}
            }).then( (res) => {
                commit('_getSmileKitchenSets', res.data)
            })
        },

        async _getGrandKitchenSets( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/grand_kitchen_sets',
                data: {}
            }).then( (res) => {
                commit('_getGrandKitchenSets', res.data)
            })
        },

        async _getSmartKitchenCounters( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/smart_kitchen_counters',
                data: {}
            }).then( (res) => {
                commit('_getSmartKitchenCounters', res.data)
            })
        },

        async _getGrandKitchenCounters( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/grand_kitchen_counters',
                data: {}
            }).then( (res) => {
                commit('_getGrandKitchenCounters', res.data)
            })
        },

        async _getSlitsliders( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/slit_sliders',
                data: {}
            }).then( (res) => {
                commit('_getSlitsliders', res.data)
            })
        },

        async _getStonePatterns( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/stone_patterns',
                data: {}
            }).then( (res) => {
                commit('_getStonePatterns', res.data)
            })
        },

        async _getHangingClosetLattices( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/hanging_closet_lattices',
                data: {}
            }).then( (res) => {
                commit('_getHangingClosetLattices', res.data)
            })
        },

        async _getBaseDrainers( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/base_drainers',
                data: {}
            }).then( (res) => {
                commit('_getBaseDrainers', res.data)
            })
        },

        async _getMoldingSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/moldingSelection',
                data: {}
            }).then( (res) => {
                commit('_getMoldingSelection', res.data)
            })
        },

        async _getFanovaEntranceDoor( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/fanovaEntrance',
                data: {}
            }).then( (res) => {
                commit('_getFanovaEntranceDoor', res.data)
            })
        },

        async _getFireproofFanova( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/fireproofFanovaEntrance',
                data: {}
            }).then( (res) => {
                commit('_getFireproofFanova', res.data)
            })
        },

        async _getPronova( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/pronova',
                data: {}
            }).then( (res) => {
                commit('_getPronova', res.data)
            })
        },

        async _getFeatureColorSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/featureColor',
                data: {}
            }).then( (res) => {
                commit('_getFeatureColorSelection', res.data)
            })
        },

        async _getJoineryColorSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/joineryColorSelection',
                data: {}
            }).then( (res) => {
                commit('_getJoineryColorSelection', res.data)
            })
        },

        async _getSmartFlooringSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/smartFlooring',
                data: {}
            }).then( (res) => {
                commit('_getSmartFlooringSelection', res.data)
            })
        },

        async _getSmileFlooringSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/smileFlooring',
                data: {}
            }).then( (res) => {
                commit('_getSmileFlooringSelection', res.data)
            })
        },

        async _getCubeFlooringSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/cubeFlooring',
                data: {}
            }).then( (res) => {
                commit('_getCubeFlooringSelection', res.data)
            })
        },

        async _getJikuFlooringSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/jikuFlooring',
                data: {}
            }).then( (res) => {
                commit('_getJikuFlooringSelection', res.data)
            })
        },

        async _getGrandFlooringSelection( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/grandFlooring',
                data: {}
            }).then( (res) => {
                commit('_getGrandFlooringSelection', res.data)
            })
        },

        async _getSmartGrandStair( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/smartGrandStair',
                data: {}
            }).then( (res) => {
                commit('_getSmartGrandStair', res.data)
            })
        },

        async _getBossCodes( {commit, state} ){
            await axios({
                method: 'POST',
                url: `/api/bossCode`,
                data: {
                    selection: state.boss_selection
                }
            }).then( (res) => {
                commit('_getBossCodes', res.data)
            })
        },

        async _getAriNashi( {commit} ){
            await axios({
                method: 'GET',
                url: '/api/ariNashi',
                data: {}
            }).then( (res) => {
                commit('_getAriNashi', res.data)
            })
        },

        async _getTileColorCombinations( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/tile_combinations',
                data: {}
            }).then( (res) => {
                commit('_getTileColorCombinations', res.data)
            })
        },

        async _getRemarks( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/remarks',
                data: {}
            }).then( (res) => {
                commit('_getRemarks', res.data)
            })
        },

        async _getExcel( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/cad_excel',
                data: {}
            }).then( (res) => {
                commit('_getExcel', res.data)
            })
        },

        async _getManual( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/cad_manual',
                data: {}
            }).then( (res) => {
                commit('_getManual', res.data)
            })
        },

        async _getHouseTypeRemarks( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/house_type_remarks',
                data: {}
            }).then( (res) => {
                commit('_getHouseTypeRemarks', res.data)
            })
        },

        async _getColorPersColumn( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/color_pers_column',
                data: {}
            }).then( (res) => {
                commit('_getColorPersColumn', res.data)
            })
        },

        async _getElectricCompanyName( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/electric_company',
                data: {}
            }).then( (res) => {
                commit('_getElectricCompanyName', res.data)
            })
        },

        async _getColorPersRestriction( {commit, state} ){
            await axios({
                method: 'POST',
                url: '/api/color_pers_column/color_pers_restriction',
                data: {
                    house_id : state.cadRequestBasicInformation.house_type_id
                }
            }).then( (res) => {
                commit('_getColorPersRestriction', res.data)
            })
        },
        async _getColorPersObjName( {commit, state} ){
            await axios({
                method: 'POST',
                url: '/api/color_pers_column/objName',
                data: {
                    house_id : state.cadRequestBasicInformation.house_type_id
                }
            }).then( (res) => {
                commit('_getColorPersObjName', res.data)
            })
        },

        async _getTileExternal({commit}) {
            await axios({
                method: 'POST',
                url: '/api/tile_external',
                data: {}
            }).then( (res) => {
                commit('_getTileExternal', res.data)
            })
        },

        setSearchItem( {commit}, payload ){
            commit('setSearchItem', payload)
        },

        async _getEntranceDoors( {commit} ){

            await axios({
                method: 'POST',
                url: '/api/entrance_door',
                data: {}
            }).then( (res) => {
                commit('_getEntranceDoors', res.data)
            })
        },

        async _getPrefectures({commit}, payload){
            await axios({
                method: 'POST',
                url: '/api/prefectures',
                data: {}
            }).then( (res) => {
                commit('_getPrefectures', res.data)
            })
        },

        async getCadRequestData({commit}, payload){
            await axios({
                method: 'POST',
                url: '/api/show',
                data: payload
            }).then(res => {
                commit('getCadRequestData', res.data)
            })
        },

        async _getPorchColors({commit}, payload){
            await axios({
                method: 'POST',
                url: '/api/porche_colors',
                data: {}
            }).then( (res) => {
                commit('_getPorchColors', res.data)
            })
        },

        async _getPorchTiles({commit}, payload){
            await axios({
                method: 'POST',
                url: '/api/porch_tiles',
                data: {}
            }).then( (res) => {
                commit('_getPorchTiles', res.data)
            })
        },

        async setCadRequestBasicInformation({commit}, payload){
            await axios({
                method: 'POST',
                url: '/api/basic_information/store',
                data: payload
            }).then((res) => {
                if(res.data != "success" && res.data != "Done!") {
                    alert(res.data);
                    return res.data;
                }
                commit('setCadRequestBasicInformation', payload)
                return payload;
            }).catch(error => {
                console.error("An error occurred:", error);
                throw error; // Rethrow the error for error handling in the component
            });
        },

        async getCadRequestBasicInformation({commit}, payload){
            await axios({
                method: 'POST',
                url: '/api/basic_information',
                data: {customerCode: payload.customer_code}
            }).then(({data}) => {
                commit('getCadRequestBasicInformation', data)
            })
        },

        async _getLatticeSliding( {commit} ) {
            await axios({
                method: 'POST',
                url: '/api/lattice_sliding',
                data: {}
            }).then( (res) => {
                commit('_getLatticeSliding',res.data)
            })
        },



        async _getFlooringSelection( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/flooring_selections',
                data: {}
            }).then( (res) => {
                commit('_getFlooringSelection', res.data)
            })
        },

        async _getKitchenCounter( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/kitchen_counters',
                data: {}
            }).then( (res) => {
                commit('_getKitchenCounter', res.data)
            })
        },

        async _getHpStair( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/hp_stairs',
                data: {}
            }).then( (res) => {
                commit('_getHpStair', res.data)
            })
        },

        async _getKanabakari( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/kanabakari_settings',
                data: {}
            }).then( (res) => {
                commit('_getKanabakari', res.data)
            })
        },


        // async _getFloorLayout( {commit} ){
        //     await axios({
        //         method: 'POST',
        //         url: '/api/floor_layout',
        //         data: {}
        //     }).then( (res) => {
        //         commit('_getFloorLayout', res.data)
        //     })
        // },

        async _getTatamiDetails( {commit} ){
            await axios({
                method: 'POST',
                url: '/api/getTatamiDetails',
                data: {}
            }).then( (res) => {
                commit('_getTatamiDetails', res.data)
            })
        },

        async _getPlanner( {commit} ) {
            const response = await axios.get('/api/get-planner-master');
            commit('_getPlanner', response.data.data);
            return response.data.data;
        },




    },

    mutations:{
        saveToken(state, payload){
            state.token = payload;
            const now = new Date();
            const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

            state.tokenExpiration = endOfDay.getTime(); 

            localStorage.setItem('token', JSON.stringify(payload));
            localStorage.setItem('tokenExpiration', state.tokenExpiration);
        },
        clearToken(state) {
            state.token = {};
            state.loggedInUser = {}
            state.tokenExpiration = null;
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpiration');
        },

        SET_EXISTING_REVISIONS(state, revisions) {
            state.existingRevisions = revisions;
        },

        login(state, payload){
            state.loggedInUser = payload
            state.loggedInUser.uniqId = `${payload.email}-${makeid(20)}`

            function makeid(length) {
                let result = '';
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                const charactersLength = characters.length;
                let counter = 0;
                while (counter < length) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                    counter += 1;
                }
                return result;
            }

            if(state.loggedInUser.deleted_at !== null){
                Swal.fire({
                    icon: "error",
                    title: "Login failed",
                    text: "Sorry, you are not allowed to use Cad Request System V2",
                    confirmButtonText: "OK"
                }).then((result) => {
                    if(result.isConfirmed){
                        state.token = {};
                        state.loggedInUser = {};
                        return;
                    }
                })
                state.token = {};
                state.loggedInUser = {};
                return;
            }else

            if(!state.loggedInUser.is_admin && !state.loggedInUser.plan_control && state.loggedInUser.deleted_at === null){
                state.columnRestriction = false;
                // window.location.href='/home';
                window.location.href='/viewtable';
                return;
            }else{
                window.location.href='/home';
            }

            
            

                
            

            
            
            // window.location.href='/cadrequest';
        },

        logout(state){
            state.loggedInUser = {}
            state.token = {}
            state.userGuest = {}
        },

        getUsers(state, data){
            state.allUsers = data
        },

        toggleViewMode(state){
            state.viewMode = !state.viewMode
        },

        toggleEditMode(state){
            state.editMode = !state.editMode
        },

        toggleFilterMode(state){
            state.filterMode = !state.filterMode
        },

        toggleSearchColumn(state, payload){
            // console.log(state[payload])
        },

        toggleLoader(state, payload){
            state.loader = payload
        },

        cadRequestVer(state, payload){
            state.cadRequestVersion = payload
            // console.log(state.cadRequestVersion,'cadRequestVersion')
            
        },

        // getXmlData(state, payload){
        //     state.XmlData = payload.filter( r=> r.created_at = r.created_at ? moment(r.created_at).format("YYYY-MM-DD HH:mm:ss") : '')
        //     console.log(state.cadRequestVersion,'cadRequestVersion')
            
        // },

        // Master Settings - with underscore('_')
        _getSekou(state, payload) {
            state.SEKOU = payload
        },

        _getStopList(state, payload) {
            state.STOP_LIST = payload
        },
        _getHouseTypeGroups(state, payload) {
            state.HOUSE_TYPE_GROUPS = payload
        },

        _getCadBasicInforRemarks(state, payload) {
            state.cadRequestBasicInformationRemarks = payload
        },

        _getHouseTypes(state, payload){
            // payload.map( (res) => state.HOUSE_TYPES.push(res));
            // payload.forEach( (el) => state.HOUSE_TYPES.push(el) );
            let currentDate = new Date()
            let triggerDate = new Date(2024, 0, 1)

            if (currentDate >= triggerDate) {
                state.HOUSE_TYPES = payload.filter((r) => r.id != 1 && r.id != 4 && r.id != 5 && r.id != 6 && r.id != 9 && r.id != 11);
            } else {
                state.HOUSE_TYPES = payload.filter((r) => r.id != 1);
            }
        },

        _getHpColumn(state, payload){
            state.HP_COLUMNS = payload
        },

        _getHpRestriction(state, payload){
            state.HP_RESTRICTIONS = payload
        },

        _getHpRestrictionPerHouseType(state, payload){
            state.HP_RESTRICTIONS_PER_HOUSE = payload
        },

        _getHpObjName(state, payload){
            state.HP_OBJ_NAME = payload
        },

        _getHouseTypeCategories(state, payload){
            state.HOUSE_TYPE_CATEGORIES = payload
        },
        
        _getTiles(state, payload){
            state.TILES = payload
        },

        _getBalconyBeltMakeupTiles(state, payload){
            state.BALCONY_BELT_MAKEUP_TILES = payload
        },

        _getEavesSelections(state,payload){
            state.EAVES_SELECTIONS = payload
        },

        _getEavesGutterSelections(state,payload){
            state.EAVES_GUTTER_SELECTION = payload
        },

        _getGableSelections(state, payload){
            state.GABLE_SELECTIONS = payload
        },

        _getSiporoks(state, payload){
            state.SIPOROKS = payload
        },

        _getViewDirectionSelections(state, payload){
            state.VIEW_DIRECTION_SELECTIONS = payload
        },

        _getViewHeightSelections(state, payload){
            state.VIEW_HEIGHT_SELECTIONS = payload
        },

        _getCombDesigns(state, payload){
            state.COMB_DESIGNS = payload
        },

        _getLouverItems(state, payload){
            state.LOUVER_ITEMS = payload
        },

        _getLouverWoods(state, payload){
            state.LOUVER_WOODS = payload
        },

        _getLouverPaints(state, payload){
            state.LOUVER_PAINTS = payload
        },

        _getRoofSelection(state, payload){
            state.ROOF_SELECTION = payload
        },

        _getColorSelectionLayout(state, payload){
            state.COLOR_SELECTION_LAYOUT = payload
        },

        _getSashType(state, payload){
            state.SASH_TYPE = payload
        },

        _getSashReinforcement(state, payload){
            state.SASH_REINFORCEMENT = payload
        },

        _getSashAccessories(state, payload){
            state.SASH_ACCESSORIES = payload
        },

        _getSashSelection(state, payload){
            state.SASH_SELECTION = payload
        },

        _getSprayItems(state, payload){
            state.SPRAY_ITEMS = payload
        },

        _getLenaRack(state, payload){
            state.LENA_RACK = payload
        },

        _getSprayShipo(state, payload){
            state.SPRAY_SHIPO = payload
        },

        _getSpraySynagio(state, payload){
            state.SPRAY_SYNAGIO = payload
        },

        _getSmileCubeStairs(state, payload){
            state.SMILE_CUBE_STAIRS = payload
        },

        _getJikuStairs(state, payload){
            state.JIKU_STAIRS = payload
        },

        _getKitchenSets(state, payload){
            state.KITCHEN_SETS = payload
        },

        _getSmileKitchenSets(state, payload){
            state.SMILE_KITCHEN_SETS = payload
        },

        _getGrandKitchenSets(state, payload){
            state.GRAND_KITCHEN_SETS = payload
        },

        _getSmartKitchenCounters(state, payload){
            state.SMART_KITCHEN_COUNTERS = payload
        },

        _getGrandKitchenCounters(state, payload){
            state.GRAND_KITCHEN_COUNTERS = payload
        },

        _getSlitsliders(state, payload){
            state.SLIT_SLIDERS = payload
        },

        _getStonePatterns(state, payload){
            state.STONE_PATTERNS = payload
        },

        _getHangingClosetLattices(state, payload){
            state.HANGING_CLOSET_LATTICES = payload
        },

        _getBaseDrainers(state, payload){
            state.BASE_DRAINERS = payload
        },

        _getMoldingSelection(state, payload){
            state.MOLDING_SELECTION = payload
        },

        _getFanovaEntranceDoor(state, payload){
            state.FANOVA_ENTRANCE = payload
        },

        _getFireproofFanova(state, payload){
            state.FIREPROOF_FANOVA = payload
        },

        _getPronova(state, payload){
            state.PRONOVA = payload
        },

        _getFeatureColorSelection(state, payload){
            state.FEATURE_COLOR = payload
        },

        _getJoineryColorSelection(state, payload){
            state.JOINERY_COLOR = payload
        },

        _getSmartFlooringSelection(state, payload){
            state.SMART_FLOORING = payload
        },

        _getSmileFlooringSelection(state, payload){
            state.SMILE_FLOORING = payload
        },

        _getCubeFlooringSelection(state, payload){
            state.CUBE_FLOORING = payload
        },

        _getJikuFlooringSelection(state, payload){
            state.JIKU_FLOORING = payload
        },

        _getGrandFlooringSelection(state, payload){
            state.GRAND_FLOORING = payload
        },

        _getSmartGrandStair(state, payload){
            state.SMART_GRAND_STAIR = payload
        },

        _getBossCodes(state, payload){
            state.BOSS_CODE = payload
        },

        _getAriNashi(state, payload){
            state.ARI_NASHI = payload
        },

        _getTileColorCombinations(state, payload){
            state.TILE_COLOR_COMBINATIONS = payload
        },

        _getRemarks(state, payload){
            state.REMARKS = payload
        },

        _getExcel(state, payload){
            state.CADEXCEL = payload
        },

        _getManual(state, payload){
            state.CADMANUAL = payload
        },

        _getHouseTypeRemarks(state, payload){
            state.HOUSE_TYPE_REMARKS = payload
        },

        _getColorPersColumn(state,payload) {
            state.COLOR_PERS_COLUMN = payload
        },

        _getColorPersRestriction(state, payload){
            state.COLOR_PERS_RESTRICTION = payload
        },
        _getElectricCompanyName(state, payload){
            state.ELECTRIC_COMPANY = payload
        },
        _getColorPersObjName(state, payload){
            state.COLOR_PERS_OBJ_NAME = payload
            // state.COLOR_PERS_OBJ_NAME = payload.filter((r) => {
            //     if(r) return r
            //     return false;
            // })
        },

        _getTileExternal(state, payload){
            state.TILE_EXTERNAL = payload
        },

        // _updateHousTypeCategories(state, payload){
        //     const index = state.HOUSE_TYPE_CATEGORIES.findIndex(res => res.id == payload.id)
        //     state.HOUSE_TYPE_CATEGORIES.splice(index, 1, payload);
        // }

        setSearchItem(state, payload){
            state.searchItem = payload
        },

        _getEntranceDoors(state, payload){
            state.ENTRANCE_DOORS = payload
        },

        _getPrefectures(state, payload){
            state.PREFECTURES = payload;
            // console.log(state.PREFECTURES,'ha')
        },

        getCadRequestData(state, payload){
            state.cadRequestData = payload
        },

        _getPorchColors(state, payload){
            state.PORCH_COLORS = payload
        }, 

        _getPorchTiles(state, payload){
            state.PORCH_TILES = payload
            // console.log(payload, "payload")
        },

        setCadRequestBasicInformation(state, payload){
            state.cadRequestBasicInformation = payload

        },

        getCadRequestBasicInformation(state, payload){
            state.cadRequestBasicInformation = payload
        },

        _getLatticeSliding(state,payload){
            state.LATTICE_SLIDING = payload
        },

        _getFlooringSelection(state, payload){
            state.FLOORING_SELECTIONS = payload
        },

        _getKitchenCounter(state, payload){
            state.KITCHEN_COUNTERS = payload
        },

        _getHpStair(state, payload){
            state.HP_STAIRS = payload
        },

        _getKanabakari(state, payload){
            state.KANABAKARI_SETTINGS = payload
        },

        // _getFloorLayout(state, payload){
        //     state.FLOOR_LAYOUT = payload
        // },

        _getTatamiDetails(state, payload){
            state.TATAMI = payload
        },


        _getPlanner(state, payload){
            state.PH6Planners = payload
        },


    },
    getters:{},
    plugins: [persistedData]
});
